export default __webpack_public_path__ + "static/media/faq.0bc1a0fd.png";